import {Fragment} from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

export const ChungTu = (props) => {

	const downloadPdf = () => {
		window.open(`https://pit.iamsoftware.com.vn/api/rest/s1/iam-entry/cert-income-tax/${props.referenceNumber}/pdf`);
	}

	const footer = (
		<div>
			<Button label="Tải PDF" icon="pi pi-file-pdf" onClick={downloadPdf} className="p-button-sm"/>
			<Button label="Đóng" icon="pi pi-times" onClick={() => props.setDisplay(0)} className="p-button-sm p-button-secondary"/>
		</div>
	);

	return (
		<Fragment>
			<Dialog header="Thông tin chứng từ"
					visible={!!props.display}
					style={{width: '100vw', maxWidth: '1000px', height: '90%'}}
					position="top"
					onHide={() => props.setDisplay(0)}
					footer={footer}>
				<div className="grid" style={{height: '100%'}}>
					<div className="col-12" style={{height: '100%'}}>
						{props.referenceNumber && (
							<iframe src={`https://pit.iamsoftware.com.vn/api/rest/s1/iam-entry/cert-income-tax/${props.referenceNumber}/pdf`}
									width="100%"
									height="100%"
									title={props.referenceNumber}
									style={{border: 'none'}}/>
						)}
					</div>
				</div>
			</Dialog>
		</Fragment>
	);
}
